import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import DebugLabel from "./DebugLabel"

const HiddenInputField = styled.input`
  max-width: 100%;
  opacity: 0.25;
  pointer-events: none;
  width: 300px;
`

export const HiddenInput = ({
  className,
  debugLabel,
  forwardRef,
  ...props
}) => {
  // Keep inside the component to enable testing with env override
  const debug = process.env.GATSBY_DEBUG_FORMS === "true"
  return (
    <>
      <HiddenInputField
        type="text"
        className={className}
        ref={forwardRef}
        hidden={!debug}
        {...props}
      />
      {debug && (
        <>
          <DebugLabel>
            <code>{props.name}</code> {debugLabel && `(${debugLabel})`}
          </DebugLabel>
          <br />
        </>
      )}
    </>
  )
}

HiddenInput.propTypes = {
  debugLabel: PropTypes.string,
  className: PropTypes.string,
  forwardRef: PropTypes.object,
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
}
export default HiddenInput
